import { Injectable } from '@angular/core';
import { UserManager, User, Log } from 'oidc-client';
import { Observable } from 'rxjs';
import { EnvironmentServiceProvider } from '../environment-service/environment-service';

@Injectable()
export class OauthCodeFlowService {

  _userManager: UserManager;
   user: User;
  // NOTE: These key and value must be the same for all the MTM Web apps
  ACTIVE_BROWSER_SESSION_KEY = 'MTM-Link_active-browser';
  ACTIVE_BROWSER_SESSION_VALUE = 'true';

  constructor(private environmentService: EnvironmentServiceProvider) {
    this._userManager = new UserManager(this.environmentService.oauthCodeFlowSettings);

    Log.logger = console; // TODO Logging for development only
    Log.level = Log.DEBUG;
    this.handlerUserLoadedEvent();
  }

  async signinRedirect(): Promise<void> {
    try {
      // Note: Force state renewal for the redirect page
      if(this.isActiveBrowserSession() || this.isIdpRedirect){
        return await this._signinRedirect();
      }
      else {
        const sessioninfo = await this._userManager.querySessionStatus();
        console.log('signinRedirect() querySessionStatus success response', sessioninfo);

        if(sessioninfo.session_state && sessioninfo.sub) {
          await this.logout();
        }
        else {
          return await this._signinRedirect();
        }
      }
    }
    catch(error) {
      console.log('signinRedirect() querySessionStatus error', error);
      return await this._signinRedirect();
    }
  }

  async signinRedirectCallback() {
     this.user = await this._userManager.signinRedirectCallback();
     return this.user;
  }

  async getUser() {
    if(this.user) {
      return this.user;
    }
    this.user = await this._userManager.getUser();
    return this.user;
  }

   getUserObservable(): Observable<User> {
    return Observable.fromPromise(this.getUser());
  }
  
  handlerUserLoadedEvent() {
    this._userManager.events.addUserLoaded(args => {
      this._userManager.getUser().then(user => {
        this.user = user;
        console.log('oauth-code-flow-service.ts handlerUserLoadedEvent()', 'new user loaded');
      });
    });
  }

  async renewToken(): Promise<User> {
    this.user = await this._userManager.signinSilent();
    return this.user;
  }

  async logout(): Promise<void> {
    this.user = null;
    return await this._userManager.signoutRedirect();
  }

  get isIdpRedirect(): boolean {
    return window.location.href.includes('/#/redirect');
  }

  isActiveBrowserSession(): boolean {
    return (window.sessionStorage.getItem(this.ACTIVE_BROWSER_SESSION_KEY) === this.ACTIVE_BROWSER_SESSION_VALUE);
  }

  activeBrowserSession() {
      // The cookie expires with the browser's session
      window.sessionStorage.setItem(this.ACTIVE_BROWSER_SESSION_KEY, this.ACTIVE_BROWSER_SESSION_VALUE);
  }

  private async _signinRedirect() {
    await this._userManager.signinRedirect({
      extraQueryParams: {
        state_timestamp: new Date().getTime()
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/oauth-code-flow-service/oauth-code-flow-service.ts